module.exports = __webpack_public_path__ + "static/media/spreadsheet.46159a6c.png";